export default "__VITE_ASSET__kfaCG1tI__"